import { Col, ColType, Crud, CrudApi } from "../../comp/crud";
import { ApiClient } from "../../api/ApiClient";

import { Form, Modal, Typography, Tabs, TabPane } from "@douyinfe/semi-ui";
import { formatFloat, formatDate } from "../../utils";
import React, { useState, useEffect } from "react";
import LeadReportItem from "./leadReportItem";
import { LeadReportItemProps } from "./leadReportItem";
import {IconUserGroup, IconUser, IconModalStroked} from "@douyinfe/semi-icons";

const apiClient = ApiClient.getDefault();
export default function OrgUserStarStat() {
  const [crudApi, setCrudApi] = useState(undefined as undefined | CrudApi);
  const [showLeadItemModal, setShowLeadItemModal] = useState(false);
  const [leadReportItemProps, setLeadReportItemProps] = useState(
    undefined as undefined | LeadReportItemProps
  );

  let cols: Col[] = [
    {
      name: "名称",
      width: 260,
      showInFilter: false,
      key: "name",
      type: ColType.STRING,
      render: (value, record, index) => {
        if (record.type == "org") {
          return (
            <Typography.Text strong type="warning">
              {value}
            </Typography.Text>
          );
        } else {
          return <Typography.Text strong>{value}</Typography.Text>;
        }
      },
    },

    {
      name: "总数",
      width: 60,
      key: "totalCount",
      type: ColType.NUMBER,
      render: (value, record, index) => {
        return (
          <Typography.Text
            link
            onClick={() => {
              openLeadItemModal(record.id, "", record.type, -1);
            }}
          >
            {value}
          </Typography.Text>
        );
      },
    },
    {
      name: "0星",
      width: 60,
      key: "star0",
      type: ColType.NUMBER,
      render: (value, record, index) => {
        return (
          <Typography.Text
            link
            onClick={() => {
              openLeadItemModal(record.id, "", record.type, 0);
            }}
          >
            {value}
          </Typography.Text>
        );
      },
    },
    {
      name: "1星",
      width: 60,
      key: "star1",
      type: ColType.NUMBER,
      render: (value, record, index) => {
        return (
          <Typography.Text
            link
            onClick={() => {
              openLeadItemModal(record.id, "", record.type, 1);
            }}
          >
            {value}
          </Typography.Text>
        );
      },
    },
    {
      name: "2星",
      width: 60,
      key: "star2",
      type: ColType.NUMBER,
      render: (value, record, index) => {
        return (
          <Typography.Text
            link
            onClick={() => {
              openLeadItemModal(record.id, "", record.type, 2);
            }}
          >
            {value}
          </Typography.Text>
        );
      },
    },
    {
      name: "3星",
      width: 60,
      key: "star3",
      type: ColType.NUMBER,
      render: (value, record, index) => {
        return (
          <Typography.Text
            link
            onClick={() => {
              openLeadItemModal(record.id, "", record.type, 3);
            }}
          >
            {value}
          </Typography.Text>
        );
      },
    },
    {
      name: "4星",
      width: 60,
      key: "star4",
      type: ColType.NUMBER,
      render: (value, record, index) => {
        return (
          <Typography.Text
            link
            onClick={() => {
              openLeadItemModal(record.id, "", record.type, 4);
            }}
          >
            {value}
          </Typography.Text>
        );
      },
    },

    {
      name: "5星",
      width: 60,
      key: "star5",
      type: ColType.NUMBER,
      render: (value, record, index) => {
        return (
          <Typography.Text
            link
            onClick={() => {
              openLeadItemModal(record.id, "", record.type, 5);
            }}
          >
            {value}
          </Typography.Text>
        );
      },
    },
    {
      name: "上门数",
      width: 60,
      key: "visitCount",
      type: ColType.NUMBER,
    },
    {
      name: ">=3星上门数",
      width: 60,
      key: "ge3VisitCount",
      type: ColType.NUMBER,
    },
    {
      name: "0星占比",
      width: 100,
      key: "starRate0",
      type: ColType.PERCENTAGE,
    },
    {
      name: "1星占比",
      width: 100,
      key: "starRate1",
      type: ColType.PERCENTAGE,
    },
    {
      name: "2星占比",
      width: 100,
      key: "starRate2",
      type: ColType.PERCENTAGE,
    },
    {
      name: ">=3星占比",
      width: 120,
      key: "starRate3",
      type: ColType.PERCENTAGE,
    },
    {
      name: ">=3星上门占比",
      width: 90,
      key: "ge3VisitRate",
      type: ColType.PERCENTAGE,
    },
    {
      name: "城市",
      key: "city",
      colSort: 2,
      hideInList: true,
      showInFilter: true,
      type: ColType.SELECT,
      getOptions: () => apiClient.getDictAsOpts("city"),
    },
    {
      name: "团队",
      key: "teamId",
      type: ColType.TREE,
      getOptions: (row) => apiClient.getTeamAsOpts(),
      hideInList: true,
      showInFilter: true,
    },

    {
      name: "日期",
      key: "createdAt",
      hideInList: true,
      showInFilter: true,
      type: ColType.DATE_RANGE,
    },
  ];

  let nowDate = new Date();
  let nowDateStr = formatDate(nowDate);
  const city = localStorage.getItem("city");
  const [initFilterValues, setInitFilterValues] = useState({
    createdAt: [nowDate, nowDate],
    city:city,
  });

  const initParams = {
    createdAt: nowDateStr + "," + nowDateStr,
    city:city,
  };

  const openLeadItemModal = async (
    id: number,
    dataType: string,
    type: string,
    star: number
  ) => {
    let queryParams = crudApi?.getQueryParams();
    let userId = null;
    let teamId = null;
    if (type == "org") {
      teamId = id;
    } else {
      userId = id;
    }
    let p: LeadReportItemProps = {
      reportType: "StatOwnerVisit",
      dataType: dataType,
      ...queryParams,
      teamId: teamId,
      userId: userId,
      star: star,
    };
    setLeadReportItemProps(p);
    setShowLeadItemModal(true);
  };

  return (
    <>
      <Tabs type="line" style={{ margin: 10 }}>
        <TabPane
          tab={
            <span>
              <IconUserGroup />
              团队纬度
            </span>
          }
          itemKey="1"
        >
          <Modal
              icon={<IconModalStroked size={"extra-large"} style={{ color: 'blue' }}/>}
            fullScreen
            title="客户列表"
            visible={showLeadItemModal}
            hasCancel={false}
            onCancel={() => setShowLeadItemModal(false)}
            okType="tertiary"
            okText="关闭"
            onOk={() => setShowLeadItemModal(false)}
              contentStyle={{ overflow: 'auto' }}
              bodyStyle={{
                height: '100%',
                padding: 0,
                overflow: 'hidden' // 父级隐藏滚动条，由内容自己管理
              }}
          >
            <LeadReportItem
              reportType={leadReportItemProps?.reportType}
              dataType={leadReportItemProps?.dataType}
              createdAt={leadReportItemProps?.createdAt}
              teamId={leadReportItemProps?.teamId}
              city={leadReportItemProps?.city}
              star={leadReportItemProps?.star}
              userId={leadReportItemProps?.userId}
            ></LeadReportItem>
          </Modal>
          <Crud
            getCrudApi={(crudApi) => {
              setCrudApi(crudApi);
            }}
            name="数据跟进报表"
            initFilterValues={initFilterValues}
            params={initParams}
            entityKey="statOrgUserStar"
            pageSize={500}
            rowActionWidth={0}
            cols={cols}
          />
        </TabPane>
      </Tabs>
    </>
  );
}
